/*
 * @Author: your name
 * @Date: 2021-11-23 17:50:36
 * @LastEditTime: 2021-11-23 18:07:18
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/services/commonService.js
 */
import request from '@/utils/request'
import API from '@/apis/api-types'

export function getDicOptionList (){
  return request({
    method: 'get',
    url: API.getDicOptionList,
  })
}

export function getAreaList (){
  return request({
    method: 'get',
    url: API.getAreaList,
  })
}